const dataOffersEnEn = [
  {
    offer: 'FOOTER_TOP',
    children: [
      {
        id: 'whatsapp',
        imageSrc: 'social-whatsapp-24.svg',
        alt: 'Need help ? need some information ?',
        title: 'Need help&nbsp;? Need some information&nbsp;?',
        text: 'Contact us with Whatsapp',
        linkTitle: 'Contact us with Whatsapp',
      },
      {
        id: 'contact',
        imageSrc: 'phone-black-24.svg',
        alt: 'Need help ? need some information ?',
        title: 'Need help&nbsp;? Need some information&nbsp;?',
        text: 'Contact us',
        linkTitle: 'Need help ? Need some information ?',
      },
      {
        id: 'acceo',
        imageSrc: 'ear-deaf-black-24.svg',
        alt: 'Deaf or hard of hearing?',
        title: 'Deaf or hard of hearing?',
        text: 'Contact us with ACCEO',
        linkTitle: 'Contact us with ACCEO',
      },
      {
        id: 'assistance',
        imageSrc: 'user-headset-black-24.svg',
        alt: 'Assistance',
        title: 'Assistance',
        text: 'Online help for optimal use',
        linkTitle: 'Assistance',
      },
    ],
  },
  {
    offer: 'FOOTER_MIDDLE_1',
    children: [
      {
        id: 'pre-contractual-document',
        text: 'Precontractual information document',
        linkUrl: 'be/en/pdf/precontractual-information.pdf',
        linkTitle: 'Precontractual information document',
      },
      {
        id: 'retraction-form',
        text: 'Withdrawal form',
        linkUrl: 'be/en/pdf/withdrawal-form.pdf',
        linkTitle: 'Withdrawal form',
      },
      {
        id: 'termination-form',
        text: 'Termination form',
        linkUrl: 'be/en/pdf/termination-form.pdf',
        linkTitle: 'Termination form',
      },
    ],
  },
  {
    offer: 'FOOTER_MIDDLE_2',
    children: [
      {
        id: 'rc-cc',
        text: 'Terms and conditions',
        linkUrl: 'be/en/terms-and-conditions',
        linkTitle: 'Terms and conditions',
      },
      {
        id: 'service-information',
        text: 'Operating information',
        linkUrl: 'be/en/operating-information',
        linkTitle: 'Operating information',
      },
      {
        id: 'prices',
        text: 'Prices',
        linkUrl: 'be/en/terms-and-conditions?anchor=pricelist',
        linkTitle: 'Prices',
      },
    ],
  },
  {
    offer: 'FOOTER_BOTTOM',
    children: [
      {
        id: 'personal-data-cookies',
        text: 'Personal data and cookies policy',
        linkUrl: 'be/en/personal-data-cookies-policy',
        linkTitle: 'Personal data and cookies policy',
      },
      {
        id: 'manage-cookies',
        text: 'Manage cookies',
        linkTitle: 'Manage cookies',
      },
      {
        id: 'launch-alert',
        text: 'Launch alert',
        linkUrl: 'https://orange.integrityline.org/',
        linkTitle: 'Launch alert',
      },
      {
        id: 'legal-information',
        text: 'Legal information',
        linkUrl: 'be/en/legal-information',
        linkTitle: 'Legal information',
      },
      {
        id: 'mediation',
        text: 'Electronic communications ombudsman',
        linkUrl: 'be/en/electronic-communications-ombudsman',
        linkTitle: 'Electronic communications ombudsman',
      },
    ],
  },
  {
    offer: 'FOOTER_LOGOS',
    children: [
      {
        id: 'nordnet',
        imageSrc: 'logo-nordnet-white.svg',
        alt: 'Nordnet',
        width: '155',
        height: '28',
      },
      {
        id: 'orange',
        imageSrc: 'logo-orange-with-baseline.png',
        alt: 'A society from Orange Group',
        width: '134',
        height: '36',
      },
    ],
  },
  {
    offer: 'FOOTER_TITLE_1',
    children: [
      {
        text: 'Practical documents',
      },
    ],
  },
  {
    offer: 'FOOTER_TITLE_2',
    children: [
      {
        text: 'Practical links',
      },
    ],
  },
];

export default dataOffersEnEn;
